import { RequestData } from '@ant-design/pro-components';

import { request } from '@umijs/max';

import {
  AddThresholdRequest,
  DeleteRequest,
  EditThresholdRequest,
  FindDateRangeDefectsRequest,
  FindDateRangeDefectsResponse,
  ThresholdDefectsResponse,
  ThresholdResponse,
  ThresholdSetResponse,
} from '@/types';

export async function getThresholdsRequest(): Promise<RequestData<ThresholdSetResponse>> {
  return request('thresholds', {
    method: 'GET',
  });
}

export async function addThreshold(payload: AddThresholdRequest): Promise<ThresholdResponse> {
  return request('thresholds', {
    data: payload,
    method: 'POST',
  });
}

export async function editThreshold({ id, ...payload }: EditThresholdRequest): Promise<ThresholdResponse> {
  return request(`thresholds/${id}`, {
    data: payload,
    method: 'PATCH',
  });
}

export async function deleteThreshold({ id }: DeleteRequest): Promise<ThresholdResponse> {
  return request(`thresholds/${id}`, {
    method: 'DELETE',
  });
}

export async function getThresholdDefects(): Promise<ThresholdDefectsResponse[]> {
  return request('thresholds/defects', {
    method: 'GET',
  });
}

export async function findDateRangeDefects(payload: null | Partial<FindDateRangeDefectsRequest>): Promise<FindDateRangeDefectsResponse[]> {
  if (!payload) {
    return [];
  }

  return request('thresholds/findDateRangeDefects', {
    data: payload,
    method: 'POST',
  });
}
